Unsplash = require('unsplash-js/dist/unsplash')
parseURL = require 'url-parse'
_ = require 'underscore'
$ = require 'jquery'
log = require 'debug/log'

APP_ID = "7066"
BASE_URL = 'https://views.unsplash.com/v?app_id=' + APP_ID

class UnsplashClient
  constructor: ->
    @appId = "454087647775b190c574339cb2994716b17ef2f83ad11838d0ef0dac2d102e66"
    @unsplashApi = new Unsplash.default
      applicationId: @appId

    @constants =
      DEFAULT_COLLECTION_ID: 317099
      PAGE_SIZE: 18
      RAW_PARAMS:
        w: 2560,
        h: 2048,
        q: 90
      ATTRIBUTION_LINK_TRACKING:
        utm_source: 'trello'
        utm_medium: 'referral'
        utm_campaign: 'api-credit'

  toJson: Unsplash.toJson

  parseUserLink: (link) =>
    url = parseURL(link, true)
    url.set('protocol', 'https:')
    _.extend(url.query, @constants.ATTRIBUTION_LINK_TRACKING)

    url.toString()

  getTrackingUrl = (params) ->
    url = BASE_URL
    url += "&#{key}=#{value}" for key, value of params
    url

  trackUnsplashViewsById: (id) =>
      if _.isArray(id)
        photoId = id.map((eachId) => encodeURIComponent(eachId)).join(',')
      else
        photoId = encodeURIComponent(id)
      trackingUrl = getTrackingUrl {
        'photo_id': photoId
      }

      $.get(trackingUrl).error (e) ->
        if e.status != 200
          log('Unsplash', 'tracking error', trackingUrl)

  trackUnsplashViews: (photos) =>
    photoIds = []
    photos.forEach((photo) =>
      if photo.isPhoto && photo.metadata.hasOwnProperty('id')
        photoIds.push photo.metadata.id
    )
    @trackUnsplashViewsById photoIds

  trackUnsplashViewBySavedUrl: (urls) =>
    photoPathArray = []
    if _.isArray(urls)
      photoPathArray = urls
    else
      photoPathArray.push(urls)

    rx = /(\/photo-)[^\&\.\?\n\#]*/g
    allPhotos = []
    photoPathArray.forEach (photo) ->
      # photo is of form http://amazon/more/more/photo-xxxxxxx if it's an unsplash photo
      # extract the `/photo-xxxxxx` portion
      photoTrimmed = rx.exec(photo)
      if photoTrimmed
        allPhotos.push(encodeURIComponent(photoTrimmed[0]))

    if allPhotos.length
      trackingUrl = getTrackingUrl {
        filepath: allPhotos.join(',')
      }

      $.get(trackingUrl).error (e) ->
        if e.status != 200
          log('Unsplash', 'tracking error', trackingUrl)


module.exports = new UnsplashClient()



// WEBPACK FOOTER //
// ./app/scripts/network/unsplash.coffee